export enum EUserRole {
  ADMINISTRATOR,
  BOARD,
  MANAGER,
  EMPLOYEE,
  TRAINEE,
  PARENT,
}
